import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12 3c.375 0 .711.231.846.581l1.65 4.29a2.85 2.85 0 0 0 1.632 1.633l4.291 1.65a.906.906 0 0 1 0 1.692l-4.29 1.65a2.84 2.84 0 0 0-1.633 1.632l-1.65 4.291a.906.906 0 0 1-1.692 0l-1.65-4.29a2.84 2.84 0 0 0-1.632-1.633l-4.291-1.65a.906.906 0 0 1 0-1.692l4.29-1.65a2.84 2.84 0 0 0 1.633-1.632l1.65-4.291A.91.91 0 0 1 12 3" }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })